import { CLMButtonPrimary } from "../v3/Buttons";
import Image from "next/image";

const CLMHero2 = ({ CLMHeroData }) => {
  return (
    <>
      <section className="max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0">
        <div className="relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0">
          <div className="flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ">
            {CLMHeroData.title && (
              <p className="text-2xl text-violet-600 uppercase">
                {CLMHeroData.title}
              </p>
            )}
            <h1 className="text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold">
              {CLMHeroData.heading}
            </h1>
            <p className="text-lg font-medium text-gray-800 md:text-2xl text-center  md:w-[80%]">
              {CLMHeroData.description}
            </p>

            <CLMButtonPrimary
              buttonText={CLMHeroData.btnText}
              buttonUrl={CLMHeroData.btnUrl}
            />
          </div>

          <div className="max-w-screen-xl md:mx-8 mx-auto pt-8">
            {CLMHeroData.video && (
              <video
                src={CLMHeroData.video}
                alt="ai-agent-builder"
                width={1216}
                height={500}
                className="rounded-xl"
                autoPlay
                loop
                muted
              />
            )}
            {CLMHeroData.image && (
              <Image
                src={CLMHeroData.image}
                alt="ai-agent-builder"
                width={1216}
                height={500}
                className="rounded-xl"
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default CLMHero2;
